import React from "react";
import { Switch } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles/index";
import CardDadosCadastrais from "../../../../components/Cards/CardDadosCadastrais";
import ItemGrid from "../../../../components/Modal/ItemGridCard";
import { InputForm } from "../../../../components/Modal/Input";
import classNames from "classnames";
import { ReactSelect, ReactSelectCheckbox } from "../../../../components/Select/SelectSearch";
import { Button } from "../../../../components/ui/Buttons";

const Card = ({
  configuracaoUnidade,
  fields,
  onChange,
  title,
  classes,
  disabled,
  withChildrens,
  childrenField,
  button,
  idPrefix,
}) => {
  const validateInputValue = (value) => {
    if (value < 0) return 0;
    return value;
  };

  const renderComponent = (field) => {
    switch (field.type) {
      case "input":
        return (
          <InputForm
            id={idPrefix ? `${idPrefix}-inp-${field.index ?? field.name}` : undefined}
            value={validateInputValue(field.value)}
            className={classes.inputContainer}
            onChange={(e) => onChange(field.name, e.target.value)}
            type="number"
            placeholder={"00"}
            disabled={disabled}
          />
        );
      case "multiSelect":
        return (
          <div className={classes.contentReactSelect}>
            <ReactSelectCheckbox
              id={idPrefix ? `${idPrefix}-sel-${field.index ?? field.value}` : undefined}
              onChange={(e) => onChange(field.value, e)}
              value={configuracaoUnidade[field.value] || []}
              className={classes.Select}
              options={field.options || []}
            />
          </div>
        );
        case "select":
        return (
          <div className={classes.contentReactSelect}>
            <ReactSelect
              id={idPrefix ? `${idPrefix}-sel-${field.index ?? field.value}` : undefined}
              onChange={(e) => onChange(field.value, e)}
              value={configuracaoUnidade[field.value] || []}
              className={classes.Select}
              options={field.optionsSelect || []}
            />
          </div>
        );
      case "" || "switch":
      default:
        return (
          <div className={classes.contentSwitch}>
            {
              configuracaoUnidade.utilizaDasa && button && <Button
                id={idPrefix ? `${idPrefix}-btn-${button.id}` : undefined}
                onClick={() => button.onClick()}
                className={classes.button}
                shape={"pill"}
                bgColor={"#fff"}
                color={"#00BBB8"}
                fontSize={"14px"}
                fontWeight={"400"}
              >{button.label}</Button>
            }
          <Switch
            id={idPrefix ? `${idPrefix}-swt-${field.index ?? field.value}` : undefined}
            checked={!!configuracaoUnidade[field.value]}
            color="primary"
            size="medium"
            onChange={() =>
              onChange(field.value, !configuracaoUnidade[field.value])
            }
            classes={{
              root: classes.switchRoot,
              icon: classes.switchIcon,
              iconChecked: classes.switchChecked,
              bar: classes.switchBar,
            }}
            disabled={disabled}
          />
        </div>
        );
    }
  };

  return (
    <CardDadosCadastrais titulo={title}>
      {!withChildrens &&
        fields?.map((field, index) => (
          <>
            {
              !field.hidden &&
              <ItemGrid
                key={index}
                size={12}
                label={field.label}
                classes={{
                  item: classNames(classes.wrapperFields, {
                    [classes.borderBottom]: index !== fields.length - 1,
                  }),
                }}
              >
                {renderComponent({...field, index})}
              </ItemGrid>
            }
          </>
        ))}
      {withChildrens &&
        fields?.map((field, index) => {
          const value = configuracaoUnidade[childrenField]?.find(
            (item) => item.campo === field.value
          )?.status;
          return (
            <ItemGrid
              key={index}
              size={12}
              label={field.label}
              classes={{
                item: classNames(classes.wrapperFields, {
                  [classes.borderBottom]: index !== fields.length - 1,
                }),
              }}
            >
              <Switch
                id={idPrefix ? `${idPrefix}-swt-${index}` : undefined}
                checked={!!value}
                color="primary"
                size="medium"
                onChange={() => onChange(field.value, !value)}
                classes={{
                  root: classes.switchRoot,
                  icon: classes.switchIcon,
                  iconChecked: classes.switchChecked,
                  bar: classes.switchBar,
                }}
                disabled={disabled}
              />
            </ItemGrid>
          );
        })}
    </CardDadosCadastrais>
  );
};

const styles = () => ({
  Select: {
    display: "flex",
    width: "200px",
    textWrap: "nowrap",
  },
  contentReactSelect: {
    display: "flex",
    textWrap: "nowrap",
  },
  inputContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#F2F2F2",
    width: "60px",
    height: "40px",
    color: "#505050",
    marginBottom: "8px",
    borderRadius: "8px",
    "&>div>input": {
      paddingRight: "0px",
    },
  },
  wrapperFields: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
    "& > div": {
      color: "#5F6368",
      fontWeight: 400,
      lineHeight: "21px",
      fontSize: "14px",
    },
  },

  switchRoot: {
    marginLeft: "-10px",
  },

  switchIcon: {
    width: "24px",
    height: "24px",
    boxShadow: "none",
    background: "#fff",
    border: "2px solid rgba(134, 134, 135, 1)",
  },
  switchChecked: {
    width: "24px",
    height: "24px",
    boxShadow: "none",
    background: "#fff",
    border: "2px solid rgba(33, 154, 151, 1)",
  },
  switchBar: {
    width: "36px",
    height: "20px",
    borderRadius: "36px",
    backgroundColor: "#868687",
    opacity: "1 !important",
    marginTop: "-10px",
    marginLeft: "-18px",
  },
  borderBottom: {
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
  },
  button: {
    width: '120px !important',
    height: '26px !important',
    border: '1px solid #00BBB8 !important',
    display: 'flex',
    padding: '2px !important',
    background: 'white !important',
    borderRadius: '4px !important',
    justifyContent: 'center'
  },
  contentSwitch: {
    display: "flex",
    gap: "5px",
    alignItems: "center"
  }
});

export default withStyles(styles)(Card);
